<template>
    <div id="fixedBtn" class="clear bcw buybar">
      <div class="buybar__content clear">
        <van-button type="primary" size="large" class="fs3" :loading="loadSta" :disabled="loadSta" loading-text="加载中...">{{text}}</van-button>
        <p class="fs2 mt15 mbm red tac" v-if="delBtn" @click="handelDel"><van-icon name="delete" class="mrn vam"/>{{delTxt}}</p>
      </div>
    </div>
</template>
<script>
import Func from "@/assets/scripts/func";
export default {
    name: 'TheBtnbar',
    props:{
        text:{
            type:String,
            default:'确定'
        },
        loadSta:{
            type:Boolean,
            default: false
        },
        delBtn:{ //删除按钮
            type:Boolean,
            default: false
        },
        delTxt:{
            type:String,
            default:'删除'
        },
    },
    data(){
        return{
            screenHeight: document.documentElement.clientHeight   // 这里是给到了一个默认值 （屏幕可见高度）
        }
    },
    methods:{
        handelDel(){
            // console.log(11111)
            this.$emit('del')
        }
    },
    mounted () {
        const that = this
        window.onresize = () => {
            return (() => {
                that.screenHeight = document.documentElement.clientHeight
            })()
        }
    },
    watch: {
        screenHeight (newV,oldV) {
            if(newV < oldV){
                // 变小
                document.getElementById('fixedBtn').style.position="static"
            }else{
                // 正常
                document.getElementById('fixedBtn').style.position="fixed"
            }
        }
    }
}


</script>
<style lang="less" scoped>
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/components/TheBtnBar.vue